export const verificationObject = (deptId: any, UserId = '') => ({
  BarCodeNumber: '',
  UserId: String(UserId),
  DepartmentId: deptId,
  userDepartment: {
    id: deptId,
  }, //,
  //UserDept : String(deptId)
});
